export const toDeg = 180 / Math.PI;
export const toRad = Math.PI / 180;
export const halfPI = Math.PI / 2;

// Generates a random number between min (inclusive) and max (exclusive)
export function random(min, max) {
	return Math.random() * (max - min) + min;
}

// Generates a random integer between and possibly including min and max values
export function randomInt(min, max) {
	return ((Math.random()*(max-min+1)) | 0) + min;
}

// Returns a random element from an array, or simply the set of provided arguments when called
export function randomChoice(choices) {
	if (arguments.length === 1 && Array.isArray(choices)) {
		return choices[(Math.random() * choices.length) | 0];
	}
	return arguments[(Math.random() * arguments.length) | 0];
};

// Clamps a number between min and max values
export function clamp(num, min, max) {
	return Math.min(Math.max(num, min), max);
}

// Pythagorean Theorem point distance calculation
export function pointDist(x1, y1, x2, y2) {
	const distX = x2 - x1;
	const distY = y2 - y1;
	return Math.sqrt(distX*distX + distY*distY);
}

// Returns the angle (in radians) between two points
export function pointAngle(x1, y1, x2, y2) {
	return halfPI + Math.atan2(y2-y1, x2-x1);
}



// WEBPACK FOOTER //
// ./src/helpers/MyMath.js